<template>
  <div>
    <v-autocomplete
      v-model="deviceSerial"
      :label="$t('components.selectors.deviceSelection.sentinelSerialNumber')"
      :items="deviceOptions"
      :search-input.sync="deviceSearch"
      @input.native="loadDevices($event, $data)"
      @change="replacePath"
      color="primary"
      autocomplete="off"
      clearable
      :item-text="formattedItemName"
      item-value="name"
      no-filter
      @click:clear="handleOnClear($event, $data)"
    >
      <template v-slot:item="{ item }">
        <span class="mr-2">
          {{ item.crm_boat.brand_name }} {{ item.crm_boat.model }} #{{
            item.crm_boat.slot_number
          }}
        </span>
        <v-spacer></v-spacer>
        <span>
          {{ item.name }}
        </span>
      </template>
      <template v-slot:selection="{ item }">
        <span class="mr-1">
          {{ item.crm_boat.brand_name }} {{ item.crm_boat.model }} #{{
            item.crm_boat.slot_number
          }}
        </span>
        <span>
          {{ item.name }}
        </span>
      </template>
    </v-autocomplete>

    <v-select
      :items="dateOptions"
      item-text="name"
      item-value="value"
      v-model="date"
      :label="$t('components.selectors.deviceSelection.selectDate')"
      @change="handleDate(date)"
    ></v-select>

    <v-menu
      v-if="showDateRange"
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dateRangeText"
          :label="$t('components.selectors.deviceSelection.dateRange')"
          readonly
          color="primary"
          clearable
          @click:clear="clearDateRange"
          @focus="openDatePicker = true"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-if="openDatePicker"
        v-model="dateRange"
        min="2019-01-01"
        range
        color="primary"
        @input="resolveDate($event, true)"
        :max="calculateMaxDate"
      ></v-date-picker>
      <!-- :max="$moment().format('YYYY-MM-DD')" -->
    </v-menu>

    <v-row v-if="canUseKnowledgeBaseBtn">
      <v-btn @click="handleHelp" text color="primary">
        <v-icon class="mr-2">mdi-help-circle</v-icon
        >{{ $t("components.selectors.deviceSelection.help") }}
      </v-btn>
    </v-row>
    <help-dialog :dialog="helpDialog" @close="closeHelpDialog"></help-dialog>
  </div>
</template>

<script>
import api from "@/utils/api";
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
export default {
  components: {
    HelpDialog,
  },
  props: [],
  data: () => ({
    deviceOptions: [],
    deviceSearch: "",
    deviceSerial: null,
    dateRange: [],
    date: 0,
    openDatePicker: false,
    menu: null,
    helpDialog: { location: null, active: false },
    canUseKnowledgeBaseBtn: false,
    showDateRange: false,
    dateOptions: [],
  }),
  created() {
    this.canUseKnowledgeBaseBtn = constraints.canUseKnowledgeBaseBtn("data");
    this.setInitialDate();

    if (
      this.$route.query &&
      this.$route.query.id &&
      this.$route.query.datefrom &&
      this.$route.query.dateto
    ) {
      this.deviceSerial = this.$route.query.id;
      this.deviceSearch = this.$route.query.id;
      this.dateRange[0] = this.$route.query.datefrom;
      this.dateRange[1] = this.$route.query.dateto;

      const isLast7Days = this.isDateRangeMatch(7);
      const isLast14Days = this.isDateRangeMatch(14);

      if (isLast7Days) {
        this.date = 0;
      } else if (isLast14Days) {
        this.date = 1;
      } else {
        this.date = 4;
        this.showDateRange = true;
      }
    }

    this.loadDevices(null, this);
  },
  watch: {
    menu(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        if (!this.dateRange || this.dateRange.length === 0) {
          this.date = 4;
          this.showDateRange = true;

          this.dateRange = [
            this.$moment().subtract(7, "days").format("YYYY-MM-DD"),
            this.$moment().format("YYYY-MM-DD"),
          ];

          this.replacePath();
        }
      }
    },
  },
  computed: {
    dateRangeText: {
      get() {
        if (this.dateRange && this.dateRange.length > 0) {
          return this.dateRange.join(" ~ ");
        } else {
          return null;
        }
      },
      set(value) {
        if (!value) {
          this.clearDateRange();
        }
      },
    },
    calculateMaxDate() {
      const date = this.$moment(this.dateRange[0]).add(1, "M");

      if (date > this.$moment()) {
        return this.$moment().format("YYYY-MM-DD");
      }

      return date.format("YYYY-MM-DD");
    },
  },
  methods: {
    isDateRangeMatch(days) {
      const expectedFrom = this.$moment()
        .subtract(days, "days")
        .toISOString()
        .substr(0, 10);
      const expectedTo = this.$moment().toISOString().substr(0, 10);
      return (
        this.dateRange[0] === expectedFrom && this.dateRange[1] === expectedTo
      );
    },
    handleDate(item) {
      let date = [];

      switch (item) {
        case 0:
          date = [
            this.$moment().subtract(7, "days").toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ];
          break;
        case 1:
          date = [
            this.$moment().subtract(14, "days").toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ];
          break;
        case 4:
          this.showDateRange = true;
          break;
      }
      if (item === 4) return;
      this.resolveDate(date, false);
    },
    clearDateRange() {
      this.dateRange = [];
      this.menu = true;
      this.openDatePicker = true;
      if (this.deviceSerial) {
        const query = { ...this.$route.query };
        delete query.datefrom;
        delete query.dateto;
        this.$router.push({ query });
      }
    },
    handleOnClear() {
      this.deviceSearch = "";
      this.loadDevices();
    },
    formattedItemName(item) {
      return `${item.crm_boat.brand_name}  ${item.crm_boat.model} #
            ${item.crm_boat.slot_number}`;
    },
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "data";
    },
    replacePath() {
      this.$router.push({
        query: Object.assign(
          {},
          {
            id: this.deviceSerial,
            datefrom: this.dateRange[0],
            dateto: this.dateRange[1],
            sensors: "",
          },
        ),
      });
    },

    setInitialDate() {
      this.dateRange = [
        this.$moment().subtract(7, "days").toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ];
      this.dateOptions = [
        {
          name: this.$t("components.selectors.deviceSelection.last7Days"),
          value: 0,
        },
        {
          name: this.$t("components.selectors.deviceSelection.last14Days"),
          value: 1,
        },
        // { name: "Last 7 days since data", value: 2 },
        // { name: "Last 14 days since data", value: 3 },
        {
          name: this.$t("components.selectors.deviceSelection.customDateRange"),
          value: 4,
        },
      ];
    },

    resolveDate(val, status) {
      if (this.dateRange.length === 2) {
        this.dateRange = val.sort(
          (a, b) =>
            this.$moment(a).format("YYYYMMDD") -
            this.$moment(b).format("YYYYMMDD"),
        );
        if (typeof this.deviceSerial !== "undefined") {
          this.$router.push({
            query: Object.assign({}, this.$route.query, {
              datefrom: this.dateRange[0],
              dateto: this.dateRange[1],
            }),
          });
        }
        this.openDatePicker = false;
        this.menu = null;
        if (this.date !== 4) {
          this.showDateRange = false;
        }
      }
    },

    loadDevices() {
      this.deviceSearch = this.deviceSearch ? this.deviceSearch : "";
      api
        .deviceSearch({ search: this.deviceSearch, boat_info: true })
        .then((resp) => {
          this.deviceOptions = resp.data.results;
        });
    },
  },
};
</script>
